export const DISTROLISTDATA = 'DISTROLISTDATA'
export const DISTRODATA = 'DISTRODATA'
export const FETCH = 'FETCH'
export const FETCH2 = 'FETCH2'
